import React from 'react';
import {
    Box,
} from '@mui/material';
// import { useStoreActions } from 'easy-peasy';
import PageLoader from '../../../components/pageloader/pageLoader';

const ClinicalCriteria = (props) => {
    const {policyData} = props;
    const policyContentRef = React.useRef(null);
    const [openLoader, setOpenLoader] = React.useState(false);
    const [text, setText] = React.useState('');
    // const policyAction = useStoreActions((actions) => actions.policy);   

    React.useEffect(() => {
        if (policyData.clinical_criteria && policyData.clinical_criteria.type && policyData.clinical_criteria.type === "url" && policyData.clinical_criteria.text) {
            setOpenLoader(true);
            let fileSrc = policyData?.clinical_criteria?.text;
            fetch(fileSrc).then((response) => {
                return response.text();
            })
            .then((html) => {
                setText(html); 
                setOpenLoader(false);
            }).catch(function (error) {
                setOpenLoader(false);            
                if (error?.response) {
                    if (error.response.status === 403) {
                        setText('Could not retrieve the content. Presigned url has expired')
                    }
                }
            });
        } else if(policyData.clinical_criteria && policyData.clinical_criteria.type && policyData.clinical_criteria.type === "text") {
            setText(policyData?.clinical_criteria?.text);
        }
    }, [policyData.clinical_criteria]);

    React.useEffect(() => {
        if (policyContentRef.current) {
            policyContentRef.current.innerHTML = text && text.trim().length > 0 ? text : 'No Data';

             // Force all links to open in a new tab
            const links = policyContentRef.current.querySelectorAll('a');
            links.forEach(link => {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            });
        }
    }, [text]);

    return (
        <Box>
            {text && text.trim().length > 0 && (
                <>
                    {/*<h2 className="sectionHeading">Clinical Criteria</h2>*/}
                    <div className="preview-header-section" style={{marginTop: '20px'}}>
                        <PageLoader openLoader={openLoader} />
                        <div ref={policyContentRef}></div>
                    </div>
                </>
            )}
        </Box>
    )
}

export default ClinicalCriteria;